// ── NAV SCROLL ──
const navbar = document.getElementById("navbar");
const navCta = document.getElementById("nav-cta");
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 60) {
        navbar.classList.add("scrolled");
        navCta.style.display = "inline-flex";
    } else {
        navbar.classList.remove("scrolled");
        navCta.style.display = "none";
    }
});
// ── FOOTER YEAR ──
document.getElementById("current-year").textContent = new Date().getFullYear();
// ── MOBILE MENU ──
const hamburger = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobileMenu");
const mobileClose = document.getElementById("mobileClose");
hamburger.addEventListener("click", ()=>mobileMenu.classList.add("open"));
mobileClose.addEventListener("click", ()=>mobileMenu.classList.remove("open"));
document.querySelectorAll(".mobile-link").forEach((link)=>{
    link.addEventListener("click", ()=>mobileMenu.classList.remove("open"));
});
// ── FADE-UP OBSERVER ──
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((e)=>{
        if (e.isIntersecting) e.target.classList.add("visible");
    });
}, {
    threshold: 0.1
});
document.querySelectorAll(".fade-up").forEach((el)=>observer.observe(el));
// ────────────────────────────────────────────────────────────
// CHAT WIDGET
// ────────────────────────────────────────────────────────────
const N8N_CHAT_URL = "https://n8npraizdev.dpdns.org/webhook/71bfe0f8-227e-466b-9d07-69fd9fe4a27b/chat";
const N8N_LEAD_URL = "https://n8npraizdev.dpdns.org/webhook/ife-lead";
// Chips answer the question the greeting just asked.
// Each maps to a natural thing a visitor would want to know.
const QUICK_REPLIES = [
    {
        label: "\uD83D\uDEE0\uFE0F What services do you offer?",
        message: "What services do you offer?"
    },
    {
        label: "\uD83D\uDE80 I have a project in mind",
        message: "I have a project in mind and I'd like to discuss it."
    },
    {
        label: "\uD83E\uDD1D What kind of clients do you work with?",
        message: "What kind of clients does Praise work with?"
    },
    {
        label: "\uD83E\uDD16 How does Ife work?",
        message: "How does this AI assistant work?"
    }
];
// Session state
function getChatId() {
    let id = sessionStorage.getItem("chatId");
    if (!id) {
        id = "chat_" + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem("chatId", id);
    }
    return id;
}
let buttonShown = false;
let leadSaved = false;
let isWaiting = false;
// ── DOM refs ──
const chatContainer = document.getElementById("chat-widget-container");
const chatBody = document.getElementById("chat-widget-body");
const chatInputEl = document.getElementById("chat-widget-input");
const chatSendBtn = document.getElementById("chat-widget-send");
const chatBubble = document.getElementById("chat-widget-button");
const chatTooltip = document.getElementById("chat-tooltip");
const chatCloseBtn = document.getElementById("chat-widget-close");
// ── Open / close ──
function openChat() {
    if (chatBody.children.length === 0) renderWelcome();
    chatContainer.style.display = "flex";
    chatBubble.style.display = "none";
    chatTooltip.style.display = "none";
    chatInputEl.focus();
}
function closeChatWidget() {
    chatContainer.style.display = "none";
    chatBubble.style.display = "flex";
    if (window.innerWidth > 768) chatTooltip.style.display = "block";
}
chatBubble.addEventListener("click", openChat);
chatTooltip.addEventListener("click", openChat);
chatCloseBtn.addEventListener("click", closeChatWidget);
// ── Welcome message + chips ──
// The greeting and chips are one unit. The greeting ends with
// a question; the chips answer it. When the user acts on either
// a chip or the free-text input, chatBody is cleared and the
// real conversation starts fresh — no orphaned greeting bubble.
function renderWelcome() {
    chatBody.innerHTML = "";
    const wrapper = document.createElement("div");
    wrapper.id = "welcome-unit";
    wrapper.className = "welcome-unit";
    const greeting = document.createElement("p");
    greeting.className = "welcome-bubble";
    greeting.innerHTML = "Hi there! \uD83D\uDC4B I'm Ife, Praise's AI assistant.<br><br>I can tell you about her services, help you figure out if she's the right fit, or get you connected if you're ready to talk. <strong>What brings you here today?</strong>";
    wrapper.appendChild(greeting);
    const chipRow = document.createElement("div");
    chipRow.className = "quick-reply-row";
    QUICK_REPLIES.forEach(({ label, message })=>{
        const chip = document.createElement("button");
        chip.className = "quick-reply-chip";
        chip.textContent = label;
        chip.addEventListener("click", ()=>{
            startConversation(message);
        });
        chipRow.appendChild(chip);
    });
    wrapper.appendChild(chipRow);
    chatBody.appendChild(wrapper);
}
// ── Start conversation ──
// Clears the welcome unit and begins the real exchange.
// Called by both chip clicks and the send button/Enter key.
function startConversation(text) {
    if (!text.trim() || isWaiting) return;
    // Clear welcome unit — greeting has served its purpose
    chatBody.innerHTML = "";
    isWaiting = true;
    chatInputEl.disabled = true;
    chatSendBtn.disabled = true;
    chatInputEl.value = "";
    appendUserMessage(text);
    showTyping();
    fetch(N8N_CHAT_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            sessionId: getChatId(),
            chatInput: text,
            action: "sendMessage"
        })
    }).then((res)=>{
        if (!res.ok) throw new Error("Network error");
        return res.json();
    }).then((data)=>{
        hideTyping();
        const reply = data.output || "Something went wrong. Please try again or email <a href='mailto:praiseidowu.dev@gmail.com' style='color:var(--purple)'>praiseidowu.dev@gmail.com</a>";
        const showConnect = data.show_connect_button === true;
        appendBotMessage(reply);
        if (showConnect && !buttonShown && !leadSaved) appendConnectButton();
    }).catch(()=>{
        hideTyping();
        appendBotMessage("Something went wrong. Please try again or email <a href='mailto:praiseidowu.dev@gmail.com' style='color:var(--purple)'>praiseidowu.dev@gmail.com</a>");
    }).finally(()=>{
        isWaiting = false;
        chatInputEl.disabled = false;
        chatSendBtn.disabled = false;
        chatInputEl.focus();
    });
}
// ── Subsequent messages (after conversation has started) ──
// Works the same as startConversation but does NOT clear chatBody.
function sendMessage() {
    const text = chatInputEl.value.trim();
    if (!text || isWaiting) return;
    // If welcome unit is still showing, clear it first
    if (document.getElementById("welcome-unit")) chatBody.innerHTML = "";
    isWaiting = true;
    chatInputEl.disabled = true;
    chatSendBtn.disabled = true;
    chatInputEl.value = "";
    appendUserMessage(text);
    showTyping();
    fetch(N8N_CHAT_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            sessionId: getChatId(),
            chatInput: text,
            action: "sendMessage"
        })
    }).then((res)=>{
        if (!res.ok) throw new Error("Network error");
        return res.json();
    }).then((data)=>{
        hideTyping();
        const reply = data.output || "Something went wrong. Please try again or email <a href='mailto:praiseidowu.dev@gmail.com' style='color:var(--purple)'>praiseidowu.dev@gmail.com</a>";
        const showConnect = data.show_connect_button === true;
        appendBotMessage(reply);
        if (showConnect && !buttonShown && !leadSaved) appendConnectButton();
    }).catch(()=>{
        hideTyping();
        appendBotMessage("Something went wrong. Please try again or email <a href='mailto:praiseidowu.dev@gmail.com' style='color:var(--purple)'>praiseidowu.dev@gmail.com</a>");
    }).finally(()=>{
        isWaiting = false;
        chatInputEl.disabled = false;
        chatSendBtn.disabled = false;
        chatInputEl.focus();
    });
}
chatSendBtn.addEventListener("click", sendMessage);
chatInputEl.addEventListener("keypress", (e)=>{
    if (e.key === "Enter") {
        e.preventDefault();
        sendMessage();
    }
});
// ── Bubble style helpers ──
function styleBotBubble(el) {
    el.style.cssText = `
        background: linear-gradient(135deg, rgba(124,92,252,0.15), rgba(157,130,253,0.15));
        color: var(--text);
        border: 1px solid var(--purple);
        border-left: 3px solid var(--purple);
        margin-left: 0;
        margin-right: auto;
        border-bottom-left-radius: 4px;
    `;
}
function appendBotMessage(html) {
    const p = document.createElement("p");
    p.innerHTML = html;
    styleBotBubble(p);
    chatBody.appendChild(p);
    chatBody.scrollTop = chatBody.scrollHeight;
    return p;
}
function appendUserMessage(text) {
    const p = document.createElement("p");
    p.textContent = text;
    p.style.cssText = `
        background: var(--bg2);
        color: var(--text);
        border: 1px solid var(--border);
        margin-left: auto;
        margin-right: 0;
        border-bottom-right-radius: 4px;
    `;
    chatBody.appendChild(p);
    chatBody.scrollTop = chatBody.scrollHeight;
}
function appendUserFormData(text) {
    const p = document.createElement("p");
    p.textContent = text;
    p.style.cssText = `
        background: var(--bg2);
        color: var(--text);
        border: 1px solid var(--border);
        margin-left: auto;
        margin-right: 0;
        border-bottom-right-radius: 4px;
        white-space: pre-wrap;
        word-wrap: break-word;
    `;
    chatBody.appendChild(p);
    chatBody.scrollTop = chatBody.scrollHeight;
}
// ── Typing indicator ──
function showTyping() {
    const el = document.createElement("div");
    el.id = "typing-indicator";
    el.className = "typing-indicator";
    el.innerHTML = "<span></span><span></span><span></span>";
    chatBody.appendChild(el);
    chatBody.scrollTop = chatBody.scrollHeight;
}
function hideTyping() {
    document.getElementById("typing-indicator")?.remove();
}
// ── Connect button ──
function appendConnectButton() {
    if (buttonShown || leadSaved) return;
    buttonShown = true;
    const wrapper = document.createElement("div");
    wrapper.className = "connect-btn-wrapper";
    const btn = document.createElement("button");
    btn.className = "connect-btn";
    btn.textContent = "Talk to Praise \u2192";
    const decline = document.createElement("span");
    decline.className = "connect-decline";
    decline.textContent = "Not now";
    btn.addEventListener("click", ()=>{
        wrapper.remove();
        appendLeadForm();
    });
    decline.addEventListener("click", ()=>{
        decline.remove(); // only remove the "Not now" link
        btn.style.opacity = "0.5";
        btn.style.fontSize = "0.8rem";
        appendBotMessage("No worries \u2014 the option is there whenever you're ready. What else can I help you with?");
    });
    wrapper.appendChild(btn);
    wrapper.appendChild(decline);
    chatBody.appendChild(wrapper);
    chatBody.scrollTop = chatBody.scrollHeight;
}
// ── Inline lead form ──
function appendLeadForm() {
    const wrap = document.createElement("div");
    wrap.className = "lead-form-wrapper";
    wrap.innerHTML = `
        <p class="lead-form-title">Let's get you connected</p>
        <div class="lead-field">
            <label>Full name <span class="req">*</span></label>
            <input type="text"  id="lf-name"    placeholder="Sarah Chen"  autocomplete="name" />
        </div>
        <div class="lead-field">
            <label>Email <span class="req">*</span></label>
            <input type="email" id="lf-email"   placeholder="sarah@company.com" autocomplete="email" />
        </div>
        <div class="lead-field">
            <label>What do you need? <span class="req">*</span></label>
            <textarea           id="lf-need"    rows="3" placeholder="e.g. automate our onboarding flow"></textarea>
        </div>
        <div class="lead-field">
            <label>Company <span class="optional">(optional)</span></label>
            <input type="text"  id="lf-company" placeholder="Acme Inc."         autocomplete="organization" />
        </div>
        <div class="lead-form-actions">
            <button class="lead-submit-btn" id="lf-submit">Send \u{2192}</button>
            <span   class="lead-cancel"     id="lf-cancel">Cancel</span>
        </div>
        <p class="lead-error" id="lf-error"></p>
    `;
    chatBody.appendChild(wrap);
    chatBody.scrollTop = chatBody.scrollHeight;
    document.getElementById("lf-name").focus();
    document.getElementById("lf-cancel").addEventListener("click", ()=>{
        wrap.remove();
        appendBotMessage("No worries \u2014 the option is there whenever you're ready.");
    });
    document.getElementById("lf-submit").addEventListener("click", ()=>{
        submitLeadForm(wrap);
    });
}
// ── Lead submission ──
async function submitLeadForm(wrap) {
    const name = document.getElementById("lf-name").value.trim();
    const email = document.getElementById("lf-email").value.trim();
    const need = document.getElementById("lf-need").value.trim();
    const company = document.getElementById("lf-company").value.trim();
    const errorEl = document.getElementById("lf-error");
    const submitBtn = document.getElementById("lf-submit");
    if (!name) {
        errorEl.textContent = "Please enter your full name.";
        return;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = "Please enter a valid email address.";
        return;
    }
    if (!need) {
        errorEl.textContent = "Please tell us what you need.";
        return;
    }
    submitBtn.disabled = true;
    submitBtn.textContent = "Sending\u2026";
    errorEl.textContent = "";
    try {
        const res = await fetch(N8N_LEAD_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                session_id: getChatId(),
                name,
                email,
                need,
                company
            })
        });
        if (!res.ok) throw new Error("Server error");
        leadSaved = true;
        wrap.remove();
        // Show user's submitted data as a user message
        const userData = `Name: ${name}\nEmail: ${email}\nNeed: ${need}${company ? `\nCompany: ${company}` : ""}`;
        appendUserFormData(userData);
        // Then show agent's success response
        appendSuccessCard(name);
    } catch  {
        submitBtn.disabled = false;
        submitBtn.textContent = "Send \u2192";
        errorEl.textContent = "Something went wrong. Please try again.";
    }
}
// ── Success message ──
function appendSuccessCard(name) {
    const p = document.createElement("p");
    p.innerHTML = `Thanks, ${name.split(" ")[0]}! Praise will be in touch shortly. Feel free to keep asking questions in the meantime.`;
    styleBotBubble(p);
    chatBody.appendChild(p);
    chatBody.scrollTop = chatBody.scrollHeight;
}

//# sourceMappingURL=path0.dc6a4dd7.js.map
